<div id="" class="">
  <div class="" id="alert-2">
    <div class="messages success-messages" *ngIf="validationResultsService.successMessages.length != 0" [@enterAnimation]>
      <div class="container">
        <button type="button" class="close" (click)="hideSuccessMessages()">&times;</button>
        <div *ngFor="let message of validationResultsService.successMessages">
          <strong>Succeeded: </strong>{{ message }}
        </div>
      </div>
    </div>
    <div class="messages error-messages" *ngIf="validationResultsService.errorMessages.length != 0" [@enterAnimation]>
      <div class="container">
        <button type="button" class="close" (click)="hideErrorMessages()">&times;</button>
        <div *ngFor="let message of validationResultsService.errorMessages">
          <strong>Error: </strong>{{ message }}
        </div>
      </div>
    </div>
    <div class="messages warning-messages" *ngIf="validationResultsService.warningMessages.length != 0" [@enterAnimation]>
      <div class="container">
        <button type="button" class="close" (click)="hideWarningMessages()">&times;</button>
        <div *ngFor="let message of validationResultsService.warningMessages">
          <strong>Warning: </strong>{{ message }}
        </div>
      </div>
    </div>
    <div class="messages info-messages" *ngIf="validationResultsService.infoMessages.length != 0" [@enterAnimation]>
      <div class="container">
        <button type="button" class="close" (click)="hideInfoMessages()">&times;</button>
        <div *ngFor="let message of validationResultsService.infoMessages">
          <strong>Note: </strong>{{ message }}
        </div>
      </div>
    </div>
  </div>
</div>
